module.exports = __webpack_public_path__ + "media/banner/banner-1-1c16b844.jpg";